// extracted by mini-css-extract-plugin
export default {"cta":"OG-z","disabled":"PG-z"};